import { useGlobalFiltersHook } from 'hooks/useGlobalFiltersHook';

import { useQueryTimelineAndDensity } from 'api/queries/timelineAndDensity.query';

import { FilterNames, getFiltersData } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';

export type UseTimelineAndDensityProvider = ReturnType<typeof useTimelineAndDensityProvider>;

export const useTimelineAndDensityProvider = ({ widgetId, localFilters, globalFilterData, endpoints }) => {
    const isInPinboard = Boolean(widgetId);
    const source = isInPinboard ? localFilters : { ...globalFilterData };

    return {
        ui: {
            state: getState(source),
            pills: useGetPills(source),
        },
        api: {
            getTimelineAndDensity: {
                instance: useQueryTimelineAndDensity(getTimelineAndDensityPayload(source), endpoints.getHeatMapSummary),
                payload: getTimelineAndDensityPayload(source),
                endpoint: endpoints.getHeatMapSummary,
            },
        },
    };
};

const useGetPills = (source) => {
    const pillsData = {
        programTags: source?.programTags ?? [],
    };

    const { pillsList: pills } = useGlobalFiltersHook({
        latestVersionId: undefined,
        source: pillsData,
    });

    return pills;
};

const getTimelineAndDensityPayload = (source) => {
    return {
        filter: {
            filters: getFiltersData({
                [FilterNames.TAG_PORTFOLIO_BOARD]: source?.programTags ?? [],
            }),
        },
    };
};

const getState = (source) => {
    return {
        //global
        programTags: source?.programTags,
    };
};
